import { Component } from '@angular/core';
import { UserManagementService } from '../../../modules/super-admin/user-manager/user-management.service';

@Component({
  selector: 'app-users-summary',
  templateUrl: './users-summary.component.html',
  styleUrls: ['./users-summary.component.scss'],
})
export class UsersSummaryComponent {
  // Injecting UserManagementService to access user-related data
  constructor(public userManagementService: UserManagementService) {}

  // Array of user summary items to display in the template
  userSummaryItems = [
    { label: 'Org Super Admin', key: 'org_super_admin_count' },
    { label: 'Org Admin', key: 'org_admin_count' },
    { label: 'Org Member', key: 'org_member_count' },
    // { label: '360 Documenter', key: '360_documenter_count' },
    // { label: 'Quality Manager', key: 'quality_manager_count' },
    { label: 'Inactive Users', key: 'inactive_users' },
    { label: 'Total', key: 'total_users' },
    { label: 'Available accounts', key: 'balance_of_users' },
  ];
}
